import type { User } from '@/types/auth';
import { mutationOptions, queryOptions } from '@tanstack/react-query';
import { sparkApi } from '../spark-client';

export const authStatusQueryOptions = queryOptions({
  queryKey: ['auth', 'status'],
  queryFn: async ({ signal }) => {
    const response = await sparkApi.get<{
      authenticated: boolean;
      has_refresh_token: boolean;
      user_id?: string;
    }>('/oauth/status', { signal });
    return response.data;
  },
  staleTime: 30_000,
  retry: false,
});

export const currentUserQueryOptions = queryOptions({
  queryKey: ['auth', 'user'],
  queryFn: async ({ signal }) => {
    const response = await sparkApi.get<{
      user: User;
      authenticated: boolean;
    }>('/oauth/salesforce/user', { signal });
    return response.data;
  },
  staleTime: 60_000,
  retry: false,
});

export const logoutMutationOptions = mutationOptions({
  mutationFn: async () => {
    const response = await sparkApi.post<{ message: string }>('/oauth/salesforce/logout');
    return response.data;
  },
});
